import { CalendarCheck, House, IdCard, LogIn, UsersRound } from "lucide-react";
import { Divider, List } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import { useClientPortalConfigContext } from "../../../../../context";
import { ROUTES } from "../../../../../routes";
import HeaderListItem from "../HeaderListItem";
import { LoginDialogMode } from "../../../../Account/Account.types";
import { getBookGroupBookingLabel } from "../../../../../utils/groupBookingLabel";

export interface INotLoggedInHeaderListProps {
    toggleDrawer: (toggle: boolean) => void;
    handleLogin: Dispatch<SetStateAction<LoginDialogMode>>;
    handleRegister: Dispatch<SetStateAction<LoginDialogMode>>;
    handleBookingAction: (route: string) => void;
}

export default function NotLoggedInHeaderList({
    toggleDrawer,
    handleLogin,
    handleRegister,
    handleBookingAction,
}: Readonly<INotLoggedInHeaderListProps>) {
    const { clientPortalConfig } = useClientPortalConfigContext();
    const groupBookingLabel = getBookGroupBookingLabel(clientPortalConfig.groupBookingLabel);

    return (
        <List data-test-id="mobile_header_list">
            <HeaderListItem
                title="Log in"
                handleClick={() => {
                    toggleDrawer(false);
                    handleLogin(LoginDialogMode.Login);
                }}
                icon={LogIn}
            />
            <HeaderListItem
                title="Register"
                handleClick={() => {
                    toggleDrawer(false);
                    handleRegister(LoginDialogMode.Register);
                }}
                icon={IdCard}
            />
            <Divider />
            <HeaderListItem
                path={ROUTES.HOME.urlPath}
                title="Home"
                handleClose={() => {
                    toggleDrawer(false);
                }}
                icon={House}
            />
            {clientPortalConfig.featureAccess?.canBookAppointments && (
                <HeaderListItem
                    path={ROUTES.APPOINTMENT_BOOKING.urlPath}
                    title="Book Appointment"
                    icon={CalendarCheck}
                    handleClick={() => {
                        toggleDrawer(false);
                        handleBookingAction(ROUTES.APPOINTMENT_BOOKING.urlPath);
                    }}
                />
            )}
            {clientPortalConfig.featureAccess?.canBookClasses && (
                <HeaderListItem
                    path={ROUTES.CLASS_BOOKING.urlPath}
                    title={groupBookingLabel}
                    icon={UsersRound}
                    handleClick={() => {
                        toggleDrawer(false);
                        handleBookingAction(ROUTES.CLASS_BOOKING.urlPath);
                    }}
                />
            )}
        </List>
    );
}
